import { initI18n } from '$lib/i18n'

// Инициализация i18n ДО первого рендера компонентов.
// В +layout.svelte через onMount это не работает: страница форматирует
// сообщения ($_()) в момент первого рендера, раньше onMount лэйаута →
// "Cannot format a message without first setting the initial locale" → белый экран.
initI18n()
